import { MarketId } from '@drift/common';
import useDriftAccountStore from 'src/stores/useDriftAccountsStore';
import useMarketsInfoStore from 'src/stores/useMarketsInfoStore';
import useInfoForCurrentlySelectedMarket from 'src/hooks/useInfoForCurrentlySelectedMarket';
import {
	getIsIsolatedTierMarket,
	shouldBlockTradingForNonIsolatedMarket,
	shouldBlockTradingForIsolatedMarket,
} from '../../PreLaunchMarketAlerts/PreLaunchMarketAlertUtils';
import { MarketType, UserAccount } from '@drift-labs/sdk';

export type IsolatedMarketContentBlockType =
	| 'isolated-market-block'
	| 'non-isolated-market-block';

export const useShouldShowIsolatedMarketContentBlock = (): {
	blockType: IsolatedMarketContentBlockType | null;
	preLaunchTickerName: string | null;
	preLaunchMarketId: MarketId | null;
} => {
	const selectedMarket = useInfoForCurrentlySelectedMarket();
	const currentUserClient = useDriftAccountStore(
		(s) => s.accounts[s.currentUserKey ?? '']?.client
	);
	const getMarketInfo = useMarketsInfoStore(
		(s) => s.getMarketInfoByIndexAndType
	);

	if (!selectedMarket?.info?.marketId)
		return {
			blockType: null,
			preLaunchTickerName: null,
			preLaunchMarketId: null,
		};

	const isPreLaunchMarket = getIsIsolatedTierMarket(
		selectedMarket.info.marketId,
		selectedMarket.info.account
	);

	if (isPreLaunchMarket) {
		if (
			shouldBlockTradingForIsolatedMarket(
				currentUserClient?.getUserAccount() as UserAccount,
				getMarketInfo
			)
		) {
			return {
				blockType: 'isolated-market-block',
				preLaunchTickerName: null,
				preLaunchMarketId: null,
			};
		}
	} else {
		if (
			shouldBlockTradingForNonIsolatedMarket(
				currentUserClient?.getUserAccount() as UserAccount,
				getMarketInfo
			)
		) {
			const preLaunchMarketPosition =
				currentUserClient?.getActivePerpPositions()[0];

			if (!preLaunchMarketPosition) {
				return {
					blockType: null,
					preLaunchTickerName: null,
					preLaunchMarketId: null,
				};
			}

			return {
				blockType: 'non-isolated-market-block',
				preLaunchTickerName:
					getMarketInfo(preLaunchMarketPosition.marketIndex, MarketType.PERP)
						?.genericInfo.symbol ?? '',
				preLaunchMarketId: MarketId.createPerpMarket(
					preLaunchMarketPosition.marketIndex
				),
			};
		}
	}

	return {
		blockType: null,
		preLaunchTickerName: null,
		preLaunchMarketId: null,
	};
};
